module.exports = __webpack_public_path__ + "img/chord_2.7e7f5ba8.jpg";